// TODO: figure out why the error is occurring when this import isn't included
import 'regenerator-runtime';

import React, { useEffect } from 'react';
import Head from 'next/head';

import {
  LIVE_VIDEO_STREAM_SHORT_TITLE, LIVE_VIDEO_PID_MAP,
} from 'lib/liveVideo';

import { AnalyticsLaunchScripts } from 'components/AnalyticsLaunchScripts';
import { LinearVideoPlayer } from 'components/LinearVideoPlayer';
import IconfontStyleTag from 'components/IconfontStyleTag';

import 'assets/styles/main.scss';
import 'assets/styles/toolkit.scss';
import classNames from 'classnames';
import globalContainerStyles from '../globalContainerStyles.module.scss';
import styles from './playmakerEmbed.module.scss';

/**
 * @param {object} props
 * @param {number} props.pid
 * @param {string} props.stream
 * @param {boolean} props.autoplay
 */
const PlaymakerEmbed = ({
  pid,
  stream,
  autoplay,
}) => {
  useEffect(() => {
    // Iframe contents height
    const divs = document.querySelectorAll('html,body');
    for (let i = 0; i < divs.length; i += 1) {
      divs[i].setAttribute('style', 'width:100%; height:100%');
    }
  }, []);

  const keyForTitle = stream ?? pid;
  const title = LIVE_VIDEO_STREAM_SHORT_TITLE[keyForTitle] ?? null;

  return (
    <>
      <Head>
        <meta name="robots" content="noindex" key="robots" />
        {title ? (<title>{title}</title>) : null}
        <IconfontStyleTag />
      </Head>
      <div
        id="CHROMELESS_LAYOUT"
        className={classNames(globalContainerStyles.container, styles.container)}
      >
        {pid && pid > 0 ? (
          <LinearVideoPlayer
            autoplay={autoplay}
            mutedAutoplay={autoplay}
            stream={stream}
            stickyEnabled
          />
        ) : (
          <div className="bg-black df flex-column justify-center items-center vh-100" data-test="video-content-not-found" data-testid="video-content-not-found">
            <div className="o-30">
              <svg width="162" height="91" viewBox="0 0 162 91" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M0.807213 67.6789C5.08388 56.5119 16.9246 52.5681 27.4491 59.3041L73 91H17.7475C6.23541 91 -2.80887 80.4904 0.807213 67.6789Z" fill="white" />
                <path fillRule="evenodd" clipRule="evenodd" d="M46.5176 31.8092L70 85L21.5614 52.1423C9.40856 44.1723 11.8727 30.5088 18.6046 24.4893C28.128 16.5185 41.591 19.2846 46.5176 31.8092Z" fill="white" />
                <path fillRule="evenodd" clipRule="evenodd" d="M79.7701 20.6769L71.0736 80L46.3267 23.5939C40.9754 9.49163 53.0155 0.254066 61.0411 0.0908889C70.2377 -0.880132 81.7769 5.92586 79.7701 20.6769Z" fill="white" />
                <path fillRule="evenodd" clipRule="evenodd" d="M115.709 23.5162L91.1892 80L83.352 29.0198C82.6845 21.2528 87.6879 21.0898 89.5233 19.6331C89.1883 18.4998 86.6862 18.4998 86.6862 18.4998H82.017C81.5165 5.22839 92.1908 -0.597858 100.865 0.048254C110.205 0.373317 120.711 10.8925 115.709 23.5162Z" fill="white" />
                <path fillRule="evenodd" clipRule="evenodd" d="M140.837 52.3353L92 85L115.009 33.0272C121.965 16.6111 138.188 19.8317 143.982 26.1063C150.273 32.2213 152.095 44.61 140.837 52.3353Z" fill="white" />
                <path fillRule="evenodd" clipRule="evenodd" d="M145.475 91H89L134.876 60.0658C146.14 52.851 158.062 59.4219 161.21 68.8817C164.522 79.4599 157.068 91 145.475 91Z" fill="white" />
              </svg>
            </div>
            <div className="founders-cond white lh-none f6 f8-l">
              <p>Sorry, this content is not currently available.</p>
            </div>
          </div>
        )}
      </div>
      <AnalyticsLaunchScripts />
    </>
  );
};

/**
 * Fetches initial props for PlaymakerEmbed
 * @param {object} ctx the context object
 * @returns {object}
 */
PlaymakerEmbed.getInitialProps = async (ctx) => {
  const {
    req: {
      params: {
        pid: pidParam,
      },
      query: {
        pid: pidQuery,
      },
    },
  } = ctx;
  const pid = pidQuery || pidParam;

  const stream = LIVE_VIDEO_PID_MAP[pid] ?? null;

  return {
    pid,
    stream,
    autoplay: ctx.req.query.autoplay,
  };
};

export default PlaymakerEmbed;
